// ══════════════════════════════════════════════════════════════
// COMPASS – User Signature Reducer (US-013)
// ══════════════════════════════════════════════════════════════

import { createReducer, on } from '@ngrx/store';
import { UserSignatureActions } from './user-signature.actions';
import { initialUserSignatureState, UserSignatureState } from './user-signature.state';

export const userSignatureReducer = createReducer(
  initialUserSignatureState,

  on(UserSignatureActions.loadSignature, (state): UserSignatureState => ({ ...state, loading: true, loadError: null })),
  on(UserSignatureActions.loadSignatureForbidden, (state): UserSignatureState => ({
    ...state,
    signature: null,
    loaded: true,
    loading: false,
    forbidden: true,
  })),
  on(UserSignatureActions.loadSignatureSuccess, (state, { signature }): UserSignatureState => ({
    ...state,
    signature,
    loaded: true,
    loading: false,
    forbidden: false,
  })),
  on(UserSignatureActions.loadSignatureFailure, (state, { error }): UserSignatureState => ({
    ...state,
    loading: false,
    loadError: error,
  })),

  on(UserSignatureActions.uploadSignature, (state): UserSignatureState => ({ ...state, uploading: true })),
  // The new signature becomes the active one only once stored; a failure keeps the previous one.
  on(UserSignatureActions.uploadSignatureSuccess, (state, { signature }): UserSignatureState => ({
    ...state,
    signature,
    loaded: true,
    loadError: null,
    uploading: false,
  })),
  on(UserSignatureActions.uploadSignatureFailure, (state): UserSignatureState => ({ ...state, uploading: false })),
);
